import { render, staticRenderFns } from "./SkillSection.vue?vue&type=template&id=3bda823a&"
import script from "./SkillSection.vue?vue&type=script&lang=js&"
export * from "./SkillSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports